"use strict";

exports.__esModule = true;
exports.system = system;

var _parser = require("./parser");

var _systemConfig = require("./systemConfig");

function system(configs) {
  const config = {};

  for (const key in configs) {
    const value = configs[key];

    if (value === true) {
      config[key] = (0, _systemConfig.createSystemConfig)({
        property: key,
        scale: key
      });
      continue;
    }

    config[key] = (0, _systemConfig.createSystemConfig)({ ...value
    });
  }

  const parser = (0, _parser.createParser)(config);
  return parser;
}